import { CloseOutlined, LinkOutlined } from '@ant-design/icons';
import { OrderDoc } from '@gooduncles/gu-app-schema';
import { Tag } from 'antd';
import { FC } from 'react';

import { formatNumber } from 'src/utils/common';
import { formatBadgeDate } from 'src/utils/date-util';

import classes from './CreateFormSection.module.scss';

interface LinkedOrderBadgeProps {
  order: OrderDoc;
  onRemove: () => void;
}

const LinkedOrderBadge: FC<LinkedOrderBadgeProps> = ({ order, onRemove }) => {
  return (
    <div className={classes.linkedOrderBadge}>
      <Tag
        icon={<LinkOutlined />}
        color='blue'
        closable
        closeIcon={<CloseOutlined />}
        onClose={onRemove}
        style={{ marginRight: 0 }}>
        주문 {formatBadgeDate(order.orderDate)} ({formatNumber(order.grandTotal ?? order.paidAmount)}원)
      </Tag>
    </div>
  );
};

export default LinkedOrderBadge;
